import { CommandEmpty, CommandGroup } from "@volca/ui/components/ui/command";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { searchHelp } from "@/help/search";
import { getAvailableHelpTopics, type HelpTopic } from "@/help/topics";
import { HelpGuideItem } from "./help-guide-item";

const guidesIn = (
  topics: HelpTopic[],
  parents: string[] = [],
): { id: string; title: string; path: string }[] =>
  topics.flatMap((topic) => [
    ...(topic.isSection
      ? []
      : [{ id: topic.id, title: topic.title, path: parents.join(" / ") }]),
    ...guidesIn(topic.children ?? [], [...parents, topic.title]),
  ]);

export const HelpSearchPage = ({
  query,
  onNavigate,
}: {
  query: string;
  onNavigate: (to: string) => void;
}) => {
  const { settings } = useBusinessProducts();
  const topics = getAvailableHelpTopics(settings);

  if (query.trim()) {
    const guides = searchHelp(topics, query);
    return (
      <>
        <CommandEmpty>No guides match.</CommandEmpty>
        {guides.length > 0 && (
          <CommandGroup heading="Guides">
            {guides.map((guide) => (
              <HelpGuideItem
                key={guide.id}
                {...guide}
                query={query}
                onGo={onNavigate}
              />
            ))}
          </CommandGroup>
        )}
      </>
    );
  }

  return (
    <>
      <CommandEmpty>No guides for this business.</CommandEmpty>
      {topics.map((product) => (
        <CommandGroup key={product.id} heading={product.title}>
          {guidesIn(product.children ?? []).map((guide) => (
            <HelpGuideItem
              key={guide.id}
              {...guide}
              query={query}
              onGo={onNavigate}
            />
          ))}
        </CommandGroup>
      ))}
    </>
  );
};
